import type { ParamSchema } from "@/lib/api";

const CREATIVE_PARAM_NAMES = new Set([
  "prompt",
  "negative_prompt",
  "system_instruction",
  "image",
  "images",
  "end_image",
  "first_frame",
  "last_frame",
  "mask",
  "reference_image",
  "reference_images",
  "reference_video",
  "reference_videos",
  "reference_audio",
  "reference_audios",
  "input_audio",
]);

export function isCreativeParameter(param: ParamSchema): boolean {
  if (param.section) return param.section === "creative";
  return CREATIVE_PARAM_NAMES.has(param.name) || param.widget === "upload" || param.widget === "multi_upload";
}
